import React, { useState } from "react";
import styled, { css } from "styled-components";

import { Icon } from "src/library/components/Icon";
import { Text } from "src/library/components/Text";
import { Icons } from "src/library/components/Icon/types";

import ProductReplacementSearch from "./ProductReplacementSearch";
import { IProduct } from "../../api/products.api";

interface ReplacementInputProps{
  //handler to update either from or to product, defined by planned replacement component, handles the changes the replacements array in the ProductReplacementForm
  updateProduct: (product?: IProduct) => void;
  //supplied product from parent, determines whether to show a product or search box.
  product?: IProduct;
  //can change depending if its a to or from product, supplied by planned replacement component
  placeholder?: string;
}

/**
 * A wrapper which groups the ProductReplacementSearch component and Selected product wrapper which represents a selected,
 * or yet to be selected product. When there is no product, a search box is shown.
 * Else the product is show with an edit icon which allows to process of searching to happen again.
 * @returns
 */
const ReplacementInput: React.FunctionComponent<ReplacementInputProps> = ({
  updateProduct, product, placeholder
}) => {
  const [ productSearch, setProductSearch ] = useState(product ? false : true);

  return !productSearch && product ? (
    <SelectedProductWrapper>
      <Text>
        {`#${product.partNumber} ${product.description} `}
      </Text>

      <div className="icon-wrapper">
        <Icon
          icon={Icons.EDIT}
          size={20}
          onClick={() => setProductSearch(true)}
        />
      </div>
    </SelectedProductWrapper>
  ) : (
    <ProductReplacementSearch
      updateReplacementHandler={product => {
        updateProduct(product);
        setProductSearch(false);
      }}
      placeholder={placeholder}
    />
  );
};

const SelectedProductWrapper = styled.div`
  ${({ theme }) => css`
    padding-right: ${theme.spacing.padding.sm};
    display: flex;
    align-items:center;
    
    .icon-wrapper{
      padding: ${theme.spacing.padding.sm};
      cursor: pointer;
      }

    span {
    padding: ${theme.spacing.margins.sm};
    border-radius: ${theme.borderRadius};
    background-color: ${theme.colors.lightGrey};
    }
  `}
`;

export default ReplacementInput;
